import React, { useState, useEffect } from "react";

const Products = ({ product, setMaterial, setTotal, setProductLabor }) => {
	function setMaterialState(newMaterial) {
		product.material = newMaterial;
	}

	function calcTotal() {
		product.total = product.labor + product.material;
	}

	if (product.labor === 0) {
		setProductLabor();
		calcTotal();
	}

	if (product.total === 0) {
		calcTotal();
	}

	useEffect(() => {
		setTotal(product.id, product.total);
	}, [product.total]);

	useEffect(() => {
		setMaterial(product.id, product.material);
	}, [product.material]);

	function ProductMaterial() {
		const [name, setName] = useState("");

		// const locale = "en-US";
		// const price = new Intl.NumberFormat(locale, {
		// 	minimumFractionDigits: 2,
		// 	maximumFractionDigits: 2,
		// }).format(product.material);

		function handleChange(e) {
			let val = e.target.value;
			//ignore values entered after 2 decimal places
			if (val.includes(".") && val.split(".")[1].length > 2) {
				e.preventDefault();
			} else {
				setName(parseFloat(val));
				setMaterialState(parseFloat(val));
			}

			calcTotal();
			setTotal(product.id, product.total);
		}

		function handlePress(e) {
			let val = e.target.value;
			//ignore values entered after 2 decimal places.
			//For some reason it needs to be compared to 1 for it to work with 0s.
			if (val.includes(".") && val.split(".")[1].length > 1) {
				e.preventDefault();
			} else {
				setName(parseFloat(val));
				setMaterialState(parseFloat(val));
			}

			calcTotal();
			setTotal(product.id, product.total);
		}

		return (
			<div className="input-group-sm col-xs-2 material input-group">
				<div className="input-group-prepend">
					<span className="input-group-text">$</span>
				</div>
				<input
					className="form-control"
					type="number"
					min="0.00"
					onChange={handleChange}
					onKeyPress={handlePress}
					value={product.material}
				/>
			</div>
		);
	}

	return (
		<div key={product.name} className="row product-data">
			<div className="col-5-lg col-4 product-data-name">
				<p>{product.name}</p>
			</div>
			<div className="col-3 product-data-material">
				<p>{ProductMaterial({ product: product })}</p>
			</div>
			<div className="col product-data-time">
				<p>{product.time.toFixed(0)} s</p>
			</div>
			<div className="col product-data-labor">
				<p>${product.labor.toFixed(2)}</p>
			</div>
			<div className="col product-data-total" id={`total-${product.id}`}>
				<p>{product.total.toFixed(2)}</p>
			</div>
		</div>
	);
};

export default Products;
